// components/clients/ClientsTable.js
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Box,
  Typography,
  Tooltip
} from '@mui/material';
import { Edit, Delete, Business } from '@mui/icons-material';
import { IVA_OPTIONS, TIPO_OPTIONS } from './parametros';

const ClientsTable = ({ clients, onEdit, onDelete, loading }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <Typography>Cargando clientes...</Typography>
      </Box>
    );
  }
console.log('Clientes recibidos en ClientsTable:', clients);
  if (!clients || clients.length === 0) {
    return (
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Business sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No hay clientes registrados
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Utiliza el botón "Agregar Cliente" para crear tu primer cliente
        </Typography>
      </Paper>
    );
  }

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 2
    }).format(amount);
  };

  const formatHours = (hours) => {
    return `${hours} hs`;
  };

  const tipoClienteMap = TIPO_OPTIONS.reduce((acc, option) => {
    acc[option.value] = option.label;
    return acc;
  }, {});

  const ivaMap = IVA_OPTIONS.reduce((acc, option) => {
    acc[option.value] = option.label;
    return acc;
  }, {});

  return (
    <TableContainer component={Paper} elevation={2}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow sx={{ bgcolor: 'primary.main' }}>
            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
              🏢 Razón Social
            </TableCell>
                        <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
              Tipo
            </TableCell>
            <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
              Horas
            </TableCell>
            <TableCell align="right" sx={{ color: 'white', fontWeight: 'bold' }}>
              Monto Base
            </TableCell>
            <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
              Condición Iva
            </TableCell>
            <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
              🔧 Acciones
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {clients.map((client, index) => (
            <TableRow 
              key={client.id || index}
              sx={{ 
                '&:nth-of-type(odd)': { bgcolor: 'action.hover' },
                '&:hover': { bgcolor: 'action.selected' }
              }}
            >
              <TableCell component="th" scope="row">
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Business color="primary" />
                  <Box>
                    <Typography variant="body1" fontWeight="medium">
                      {client.razon_social}
                    </Typography>
                    {client.id && (
                      <Typography variant="caption" color="text.secondary">
                        ID: {client.id}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </TableCell>

              <TableCell align="center">
                <Chip 
                  label={tipoClienteMap[client.tipo]} 
                  color="info" 
                  variant="outlined"
                  size="small"
                />
              </TableCell>

              
              <TableCell align="center">
                <Chip 
                  label={formatHours(client.horas)} 
                  color="info" 
                  variant="outlined"
                  size="small"
                />
              </TableCell>
              
              <TableCell align="right">
                <Typography variant="body1" fontWeight="medium" color="success.main">
                  {formatCurrency(client.monto_base)}
                </Typography>
              </TableCell>
                <TableCell align="center">
                  <Chip 
                    label={ivaMap[Number(client.iva)]} 
                    color="info" 
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
              
              <TableCell align="center">
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                  <Tooltip title="Editar cliente">
                    <IconButton 
                      color="primary" 
                      onClick={() => onEdit(client)}
                      size="small"
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  
                  <Tooltip title="Eliminar cliente">
                    <IconButton 
                      color="error" 
                      onClick={() => onDelete(client)}
                      size="small"
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      
      <Box sx={{ p: 2, bgcolor: 'grey.50', textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          Total de clientes: {clients.length}
        </Typography>
      </Box>
    </TableContainer>
  );
};

export default ClientsTable;